<template>
    <div>

        <!-- Mededelingen -->
        <div class="d-flex align-items-start">
            <h2>
                <i class="fa fa-bell"></i>
                Mededelingen
            </h2>
            <div class="ms-auto mt-2">
                <button v-on:click="updateComponentVisability(componentId)" class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#announcements" aria-expanded="true" aria-controls="announcements">
                    <i class="fa fa-chevron-down" aria-hidden="true"></i>
                </button>
            </div>
        </div>

        <div v-if="loading">
            <div class="loading-spinner"><i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw"></i></div>
        </div>

        <div class="fade-in" :class="{ 'loaded': ! loading }">

            <div class="collapse" :class="{'show': componentIsVisable}" id="announcements">

                <div v-if="userCanEdit" class="d-flex mt-3 mb-3">
                    <div class="text-decoration-none text-nowrap me-4" role="button">
                        <span class="bg-lightyellow text-primary round-btn me-2">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                        </span>
                        <span v-on:click="addAnnouncement()" class="fw-semibold">
                            Nieuwe mededeling
                        </span>
                    </div>
                    <div class="text-decoration-none text-nowrap" role="button">
                        <span class="bg-lightyellow text-primary round-btn me-2">
                            <i class="fa fa-archive" aria-hidden="true"></i>
                        </span>
                        <span v-on:click="showArchivedAnnouncements()" class="fw-semibold">
                            Archief
                        </span>
                    </div>
                </div>

                <div role="button">
                    <div v-if="this.data.announcements.length > 0">
                        <ul class="announcements list-unstyled w-100 mb-0">
                            <li v-for="announcement in this.data.announcements"
                                class="d-flex align-items-center"
                            >
                                <div class="content border-bottom border-default flex-grow-1 pb-1 pt-2 ps-2"
                                     :class="{ announcement: announcement.viewed_at == null}"
                                     data-bs-toggle="modal"
                                     data-bs-target="#announcementsModal"
                                     @click="showAnnouncement(announcement)">
                                    <p class="mb-0 text-sm fw-semibold">
                                        {{ announcement.title }}
                                    </p>
                                    <p class="mb-0 text-lightgrey text-xs">
                                        {{ announcement.time_diff }}
                                    </p>
                                </div>
                                <div class="actions ms-auto">
                                    <span>
                                        <i v-if="userCanEdit" class="fa fa-pencil me-2" @click.stop="editAnnouncement(announcement)"></i>
        <!--                                <i v-if="!userCanEdit"  class="fa fa-eye-slash me-2" @click.stop="hideAnnouncement(announcement)"></i>-->
                                        <i v-if="userCanEdit" class="fa fa-eye-slash me-2" @click.stop="archiveAnnouncement(announcement)"></i>
                                        <i v-if="userCanEdit" class="fa fa-trash-o" @click.stop="deleteAnnouncement(announcement)"></i>
                                    </span>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div v-else>Geen mededelingen</div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>

    import {EventBus} from "../../event-bus";
    import {usePolling} from "../../composables/usePolling";
    import {useComponentVisibility} from "../../composables/useComponentVisibility";

    export default {
        name: 'announcements',
        components: {},
        props: {
            isVisible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                data: {
                    announcements: [{
                        key: {
                            id: '',
                            title: '',
                            description: '',
                            published: '',
                            date_from: '',
                            date_till: '',
                            time_diff: '',
                            show_popup: '',
                            roles: '',
                            viewed_at: '',
                        },
                    }],
                    showAnnouncementModalPopUp: {},
                },

                userCanEdit: false,

                componentId: 'announcement-component',
                componentIsVisable: this.isVisible,
                componentVisibility: useComponentVisibility(),
                loading: true,
            }
        },
        computed: {},
        watch: {},
        methods: {
            updateComponentVisability(component_id) {
                // Toggle the visibility state
                this.componentIsVisable = !this.componentIsVisable;
                axios.get('api/update-component-visability', {
                    params: {
                        component_id: component_id,
                        is_visable: this.componentIsVisable
                    }
                });
            },
            addAnnouncement() {
                EventBus.$emit('openAnnouncementModal');
            },
            getAnnouncements() {
                axios.get('api/announcements')
                    .then(response => {
                        this.data.announcements = response.data.announcements;
                        this.data.showAnnouncementModalPopUp = response.data.showAnnouncementModalPopUp;

                        this.userCanEdit = response.data.userCanEdit;
                        if (! this.userCanEdit) {
                            if (this.data.showAnnouncementModalPopUp) {
                                EventBus.$emit('showAnnouncementViewModal', this.data.showAnnouncementModalPopUp);
                            }
                        }

                        this.componentId = response.data.componentId;
                        this.loading = false;
                    })
                    .catch(e => {
                        this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het ophalen van de data", "error");
                    });
            },
            showAnnouncement(announcement) {
                EventBus.$emit('showAnnouncementViewModal', announcement);
            },
            showArchivedAnnouncements() {
                EventBus.$emit('openArchivedAnnouncementsModal');
            },
            hideAnnouncement(announcement) {
                axios.post('api/hide-announcement-user', {
                    announcementId: announcement.id,
                })
                    .then(response => {
                        if (response.data.status === 422) {
                            throw [true, response.data.message];
                        }

                        this.getAnnouncements();
                    })
                    .catch(e => {
                        this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het opslaan van de gegevens.", "error");
                    });
            },
            editAnnouncement(announcement) {
                EventBus.$emit('openAnnouncementModal', announcement);
            },
            archiveAnnouncement(announcement) {
                let parent = this;

                this.$swal({
                    title: "Mededeling archiveren. Weet je het zeker?",
                    text: "",
                    showCancelButton: true,
                    cancelButtonColor: "#3EBE00",
                    confirmButtonColor: "#DD3444",
                    confirmButtonText: "Ja, archiveren",
                    cancelButtonText: "Annuleren",
                }).then(
                    function (callBack) {
                        if (callBack.isConfirmed) {
                            axios.post('api/archive-announcement', {
                                announcementId: announcement.id,
                            })
                            .then(response => {
                                if (response.data.status === 422) {
                                    throw [true, response.data.message];
                                }

                                parent.getAnnouncements();
                            })
                            .catch(e => {
                                this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het opslaan van de gegevens.", "error");
                            });
                        }
                    }
                );
            },
            deleteAnnouncement(announcement) {
                let parent = this;

                this.$swal({
                    title: "Mededeling verwijderen. Weet je het zeker?",
                    text: "Deze actie kan niet ongedaan gemaakt worden.",
                    showCancelButton: true,
                    cancelButtonColor: "#3EBE00",
                    confirmButtonColor: "#DD3444",
                    confirmButtonText: "Ja, verwijderen",
                    cancelButtonText: "Annuleren",
                }).then(
                    (callBack) => {
                        if (callBack.isConfirmed) {
                            axios.delete('api/delete-announcement/'+announcement.id)
                                .then(response => {
                                    if (response.data.status === 422) {
                                        throw [true, response.data.message];
                                    }

                                    parent.getAnnouncements();
                                })
                                .catch(e => {
                                    this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het verwijderen van de mededeling.", "error");
                                });
                        }
                    }
                );
            },
        },
        mounted() {
            const { startPolling } = usePolling(() => {
                this.getAnnouncements();
            }, 60000);

            startPolling();

            EventBus.$on('refetchAnnouncements', () => {
                this.getAnnouncements();
            });
        },
        created() {},
    }
</script>
